import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/resetPassword',
    method: 'post',
    data
  })
}
